import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, delay, switchMap } from 'rxjs/operators';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';

/**
 *guard para proteger rutas en donde una sesion valida activa es requerida
 *
 * @export
 * @class AuthGuard
 * @implements {CanActivate}
 */
@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authSvc: AuthenticationService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const isEmbedded = route.queryParams['isEmbedded'] === 'true';
    const delayIfEmbedded = isEmbedded
      ? of(true).pipe(delay(2000))
      : of(true);

    return delayIfEmbedded.pipe(
      switchMap(() =>
        this.authSvc.isLogged().pipe(
          map((can) => {
            if (!can) {
              return this.router.createUrlTree(['/auth', 'login']);
            }

            this.authSvc.activateTokenRefresh().subscribe();
            return can;
          })
        )
      )
    );
  }
}
